<template>
  <div>
    <div class="mt-2" v-if="tableData.length > 0">
      <b-row class="pt-2">
        <b-col sm="4" class="mt-2">
          <b-form-select v-model="perPage" :options="options"></b-form-select>
        </b-col>
        <b-col sm="4" class="mt-2">
          <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
          <b-button variant="link" @click="resetTable()">{{
            $t("action.reset")
            }}</b-button>
        </b-col>
        <b-col sm="4" class="mt-2">
          <div>{{ $t("label.tablesize") }} {{ rows }}</div>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col class="lgTable">
          <b-table id="taskManagementTable" stacked="lg" bordered :fields="myfields" :items="items"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
            <template v-slot:cell(details)="row">
              <b-button variant="outline-success" class="ml-2" size="sm" @click="openmodal('addEditModal', row.item)">{{
                $t("label.edit") }}</b-button>
              <b-button variant="outline-danger" class="ml-2" size="sm" @click="openmodal('deleteModal', row.item)">{{
                $t("action.delete") }}</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col sm="6" class="mt-2">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="CRUDTable"></b-pagination>
        </b-col>
      </b-row>
    </div>

    <b-row class="pt-4">
      <b-col class="mt-2">
        <b-button variant="success" @click="openmodal('addEditModal', null)">{{
          $t("label.add")
          }}</b-button>
      </b-col>
    </b-row>

    <!-- <b-row class="pt-4">
      <b-col class="mt-2">
        <b-button variant="success" @click="AddMemberToAllGroup()">
          AddMemberToAllGroup
        </b-button>
      </b-col>
    </b-row> -->

    <b-modal id="addEditModal" :title="modalTitle" hide-footer>
      <AddEditModal :values="tableRowItem" :tableData="tableData" :type="type" />
    </b-modal>

    <b-modal id="deleteModal" title="Confirmation" hide-footer>
      <DeleteModal :values="tableRowItem" :type="type" modalid="deleteModal" />
    </b-modal>

    <b-modal id="pushCategory" title="Confirmation" hide-footer>
      <PushLabelModal :taskItemList="tableData" :groupBuilding="groupBuilding" />
    </b-modal>

    <b-row v-if="error" class="text-center pt-4">
      <b-col>
        <b-alert show variant="danger">
          <p>{{ error }}</p>
        </b-alert>
      </b-col>
    </b-row>

    <div v-if="spinner" class="text-center align-middle">
      <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning"
        disabled="labelStatus"></b-spinner>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import AddEditModal from "../../modal/AddEditModal";
import DeleteModal from "../../modal/DeleteModal";
import PushLabelModal from "../../modal/PushLabelModal";

export default {
  mixins: [globalF],
  props: ["type"],
  data() {
    return {
      tableRowItem: null,
      sortBy: "Id",
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      search: "",
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      spinner: false,
      disabled: false,
      error: "",
      tableData: [],
      groupBuilding: [],
    };
  },
  mounted() {
    this.$root.$on("bv::modal::hide", () => {
      this.getData();
    });
    this.getData();
  },
  computed: {
    currentLg: function () {
      return this.$i18n.locale;
    },
    modalTitle: function () {
      return this.tableRowItem ? this.$t("label.edit") : this.$t("label.add");
    },
    selectLabel: function () {
      let type = this.type;
      let label = "";
      if (type === "bucket") {
        label = this.$t("label.bucketList");
      } else {
        label = this.$t("label.labelList");
      }
      return label;
    },
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.tableData;
      let search = this.search.toLowerCase();

      return mydatalist.filter(
        (p) =>
          p.fr.toString().toLowerCase().includes(search) ||
          p.en.toString().toLowerCase().includes(search) ||
          p.value.toString().toLowerCase().includes(search)
      );
    },
    myfields: function () {
      let obj = [];

      obj = [
        { key: "Id", sortable: true, label: "Id" },
        { key: "fr", sortable: true, label: this.$t("label.french") },
        { key: "en", sortable: true, label: this.$t("label.english") },
        { key: "details", label: this.$t("label.details") },
      ];

      return obj;
    },
  },
  methods: {
    resetTable: function () {
      this.search = "";
    },
    openmodal: function (id, rowItem) {
      this.tableRowItem = rowItem;
      this.$bvModal.show(id);
    },
    getData: function () {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      axios
        .post(
          url,
          { request: "getTaskItemList", taskType: this.type },
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.spinner = false;
          this.tableData = response.data.taskItemList;
          this.groupBuilding = response.data.teamBuildings;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    AddMemberToAllGroup() {
      this.spinner = true;
      let teamSelect = this.groupBuilding;
      let requestAddMember = [];
      let token = this.getGlobalData("accessToken");
      //let userId1 = "";
      //let userId2 = "";
      let userId3 = "";

      for (let i = 0; i < teamSelect.length; i++) {
        let groupId = teamSelect[i].GroupId;

        let body = {
          "@odata.id": `https://graph.microsoft.com/v1.0/users/${userId3}`
        }
        requestAddMember.push(this.AddMember(token, groupId, body));

        /*
        //Add multiple member add once
        let body = {
          "members@odata.bind": [
            `https://graph.microsoft.com/v1.0/directoryObjects/${userId1}`, 
            `https://graph.microsoft.com/v1.0/directoryObjects/${userId2}`, 
            `https://graph.microsoft.com/v1.0/directoryObjects/${userId3}`
          ]
        }

        requestAddMember.push(this.AddMultipleMember(token, groupId, body));*/
      }

      Promise.allSettled(requestAddMember).then((results) => {

        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            console.log(`Promise ${index + 1} fulfilled:`, result.value);
          } else {
            console.error(`Promise ${index + 1} rejected:`, result.reason);
          }
        });

        this.spinner = false;
      });
    },
    AddMember: function (token, groupId, body) {
      //let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/owners/$ref`;
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members/$ref`;

      return axios.post(graphEndpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    AddMultipleMember: function (token, groupId, body) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}`;

      return axios.patch(graphEndpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    addBucketToPlanWithLimit(start, end) {

      this.spinner = true;
      let token = this.getGlobalData("accessToken");
      let requestBuckets = [];
      let taskItemList = this.tableData;

      let teamSelect = this.groupBuilding;
      let provinceBuilding = [];
      let qcGroupBuilding = [];
      let provinceList = ["Québec", "(Québec)", "(Qc)", "QC", "QUÉBEC", "québec"];

      console.log(teamSelect);

      for (let i = 0; i < teamSelect.length; i++) {
        let groupBuilding = teamSelect[i];

        if (provinceList.includes(groupBuilding.Province) /*&& groupBuilding.GroupId === 'f7665941-7a80-4787-9cd1-0ae0d1334842'*/) {
          provinceBuilding.push(groupBuilding);
        }
      }

      console.log(provinceBuilding);

      for (let i = start; i < end; i++) {
        let groupBuilding = provinceBuilding[i];
        qcGroupBuilding.push(groupBuilding);
      }

      console.log(qcGroupBuilding);

      for (let i = 0; i < qcGroupBuilding.length; i++) {
        let planId = qcGroupBuilding[i].PlanId;
        let lg = qcGroupBuilding[i].Language;

        //Add plan bucket
        for (let j = 0; j < taskItemList.length; j++) {
          let taskItem = taskItemList[j];
          let obj = {
            "name": lg === 'fr' ? taskItem.fr : taskItem.en,
            "planId": planId,
            "orderHint": " !"
          }
          requestBuckets.push(this.addPlanBucket(token, obj));
        }
      }
      Promise.allSettled(requestBuckets).then((results) => {
        console.log(results);
        this.spinner = false;
      });
    },
    addNewPlan() {
      this.spinner = true;
      let token = this.getGlobalData("accessToken");
      let requestAddNewPlan = [];

      let teamSelect = this.groupBuilding;
      let qcGroupBuilding = [];
      let provinceList = ["Québec", "(Québec)", "(Qc)", "QC", "QUÉBEC", "québec"];

      console.log(teamSelect);

      for (let i = 0; i < teamSelect.length; i++) {
        let groupBuilding = teamSelect[i];

        if (provinceList.includes(groupBuilding.Province) /*&& groupBuilding.GroupId === 'f7665941-7a80-4787-9cd1-0ae0d1334842'*/) {
          qcGroupBuilding.push(groupBuilding);
        }
      }

      console.log(qcGroupBuilding);

      for (let i = 0; i < qcGroupBuilding.length; i++) {
        let groupId = qcGroupBuilding[i].GroupId;
        let planName = qcGroupBuilding[i].GroupName;
        let obj = {
          "container": {
            "url": `https://graph.microsoft.com/v1.0/groups/${groupId}`
          },
          "title": planName
        }

        requestAddNewPlan.push(this.createPlan(token, obj));
      }

      Promise.allSettled(requestAddNewPlan).then((results) => {
        //set plans group
        qcGroupBuilding = this.setNewPlan(results, qcGroupBuilding);
        console.log(qcGroupBuilding);
      });
    },

    removePlan() {
      this.spinner = true;
      let token = this.getGlobalData("accessToken");
      let requestPlans = [];
      let requestDeletePlan = [];
      let groupNoOrManyPlan = [];
      let teamSelect = this.groupBuilding;
      let qcGroupBuilding = [];
      let provinceList = ["Québec", "(Québec)", "(Qc)", "QC", "QUÉBEC", "québec"];

      console.log(teamSelect);

      for (let i = 0; i < teamSelect.length; i++) {
        let groupBuilding = teamSelect[i];

        if (provinceList.includes(groupBuilding.Province) /*&& groupBuilding.GroupId === 'f7665941-7a80-4787-9cd1-0ae0d1334842'*/) {
          qcGroupBuilding.push(groupBuilding);
        }
      }

      console.log(qcGroupBuilding);

      for (let i = 0; i < qcGroupBuilding.length; i++) {
        let groupId = qcGroupBuilding[i].GroupId;
        requestPlans.push(this.getGroupPlan(token, groupId));
      }

      Promise.allSettled(requestPlans).then((results) => {
        //set plans group
        qcGroupBuilding = this.setGroupPlan(results, qcGroupBuilding);
        console.log(qcGroupBuilding);
        for (let i = 0; i < qcGroupBuilding.length; i++) {
          let plansOfGroup = qcGroupBuilding[i].plansOfGroup;

          if (plansOfGroup.length === 1) {
            let plan = plansOfGroup[0];
            let planId = plan.id;
            let etag = plan["@odata.etag"];

            requestDeletePlan.push(this.deletePlan(token, planId, etag));
          }
          else {
            groupNoOrManyPlan.push(qcGroupBuilding[i]);
          }
        }
        Promise.allSettled(requestDeletePlan).then((results) => {
          console.log(results);
          console.log(groupNoOrManyPlan);
          this.spinner = false;
        });
      });
    },
    deletePlan(token, planId, etag) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/plans/${planId}`;
      return axios.delete(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "If-Match": etag,
        },
      });
    },
    createPlan(token, obj) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/plans`;
      return axios.post(graphEndpoint, obj, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
    },
    addNewBucketToPlan() {
      this.spinner = true;
      //let onGroupBuilding = [];

      let token = this.getGlobalData("accessToken");
      let teamSelect = this.groupBuilding;
      let qcGroupBuilding = [];
      let provinceList = ["Québec", "(Québec)", "(Qc)", "QC", "QUÉBEC", "québec"];

      console.log(teamSelect);

      for (let i = 0; i < teamSelect.length; i++) {
        let groupBuilding = teamSelect[i];

        if (provinceList.includes(groupBuilding.Province) /*&& groupBuilding.GroupId === 'f7665941-7a80-4787-9cd1-0ae0d1334842'*/) {
          qcGroupBuilding.push(groupBuilding);
        }
      }

      console.log(qcGroupBuilding);

      let requestPlans = [];
      //let requestBuckets = [];

      for (let i = 0; i < qcGroupBuilding.length; i++) {
        let groupId = qcGroupBuilding[i].GroupId;
        requestPlans.push(this.getGroupPlan(token, groupId));
      }

      //get plans of Group
      Promise.allSettled(requestPlans).then((results) => {
        //set plans group
        qcGroupBuilding = this.setGroupPlan(results, qcGroupBuilding);
        console.log(qcGroupBuilding);
        for (let i = 0; i < qcGroupBuilding.length; i++) {
          /*let plansOfGroup = qcGroupBuilding[i].plansOfGroup;
          let groupId = qcGroupBuilding[i].GroupId;
          if (plansOfGroup.length === 1) {
            let plan = plansOfGroup[0];
          }*/
          /*if (plansOfGroup.length != 1) {
            console.log(qcGroupBuilding[i]);
          }*/
          /*if (plansOfGroup.length > 0) {
            let plan = plansOfGroup[0];
            let obj = {
                "name": "Capex",
                "planId": plan.id,
                "orderHint": " !"
            }
            requestBuckets.push(this.addPlanBucket(token, obj));
          }*/
        }
        /*Promise.allSettled(requestBuckets).then((results) => {
          console.log(results);
          this.spinner = false;
        });*/
      });
    },
    addPlanBucketToAllGroup() {
      this.spinner = true;
      let teamSelect = this.groupBuilding;
      //let taskItemList = this.tableData;
      let token = this.getGlobalData("accessToken");
      let requestPlans = [];
      let requestBuckets = [];

      for (let i = 0; i < teamSelect.length; i++) {
        let groupId = teamSelect[i].GroupId;
        requestPlans.push(this.getGroupPlan(token, groupId));
      }

      //get plans of Group
      Promise.allSettled(requestPlans).then((results) => {
        //set plans group
        teamSelect = this.setGroupPlan(results, teamSelect);
        //let groupWithNoPlan = [];

        for (let i = 0; i < teamSelect.length; i++) {
          let plansOfGroup = teamSelect[i].plansOfGroup;
          if (plansOfGroup.length > 0) {
            //Add plan bucket
            /*for (let j = 0; j < taskItemList.length; j++) {
              let taskItem = taskItemList[j];
              let obj = {
                "name": taskItem.en, //teamSelect[i].Language === 'fr' ? taskItem.fr : taskItem.en,
                "planId": plan.id,
                "orderHint": " !"
              }
              requestBuckets.push(this.addPlanBucket(token, obj));
              //requestBuckets.push(obj);
            }*/
          }
        }

        console.log(requestBuckets);

        Promise.allSettled(requestBuckets).then((results) => {
          console.log(results);
          this.spinner = false;
        });
      });
    },
    getGroupPlan(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/planner/plans`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setNewPlan(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");
      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let newPlan = successList[i].value.data;
          teamSelect[i].newPlan = newPlan;
        }
      }
      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        console.log(errorList);
      }
      return teamSelect;
    },
    setGroupPlan(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");
      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let plansOfGroup = successList[i].value.data.value;
          teamSelect[i].plansOfGroup = plansOfGroup;
        }
      }
      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        console.log(errorList);
      }
      return teamSelect;
    },
    addPlan(token, body) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/plans`;
      return axios.post(graphEndpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    addPlanBucket(token, body) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/buckets`;
      return axios.post(graphEndpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setPlanBucket(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");

      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let bucketOfPlans = successList[i].value.data.value;
          //teamSelect[i].bucketSelect = null; //bucketOfPlans[0].id;
          teamSelect[i].bucketOfPlans = bucketOfPlans;
          //teamSelect[i].labelSelect = null;
        }
      }

      return teamSelect;
    },
  },
  components: {
    AddEditModal,
    DeleteModal,
    PushLabelModal
  },
};
</script>
